import WebGalleryVideoListing from './WebGalleryVideoListing';

export default WebGalleryVideoListing;
